import { Action } from './types'
import { ApolloClient } from 'apollo-client'
import { NormalizedCache } from 'apollo-cache-inmemory'
import { UserData } from '../reducers'
import { wsClient } from '../index'

export function loginComplete(userData: UserData): Action {
  // Close the WebSocket client for now, this forces connection params to be reloaded
  wsClient.close(false, false)
  return {
    type: 'USER_LOGIN_COMPLETE',
    payload: userData
  }
}

export function logout(client?: ApolloClient<NormalizedCache>): Action {
  localStorage.removeItem('peikko-dbs-token')

  // Make sure we no longer supply authentication token into the subscription
  wsClient.close(false, false)

  if (client) {
    client.resetStore()
  }
  return {
    type: 'USER_LOGOUT'
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.ts